/** 
 * @TercioSantos-1 |
 * api/get/todas as configurações de 1 empresa |
 * api/get/1 configuração específica |
 * api/put/atualização de 1 configuração |
 */
import api from "../../services/api";
import { cachedApi } from "../../services/cachedApi";

const useCompanySettings = () => {

    const getAll = (companyId) => cachedApi.companySettings.all(companyId);

    const get = (params) => cachedApi.companySettings.one(params);

    const update = async (data) => {
        const { data: responseData } = await api.request({
            url: '/companySettings',
            method: 'PUT',
            data
        });
        cachedApi.companySettings.invalidate();
        return responseData;
    }

    return {
        getAll,
        get,
        update
    }
}

export default useCompanySettings;